module.exports = __webpack_public_path__ + "static/media/b-icon.c7177d4e.svg";